module.exports = __webpack_public_path__ + "img/IMG_8968.37143bbf.jpg";